/****************************************/
var custom_grid_isotope = [];
var custom_grid_loaded = 0;
/****************************************/

/****************************************/
function customGridResponsive(object){
  
  if(object.action == "setup"){
    /* -- Jquery Initialization Doesn't Work -- */
    if($(".random-grid").attr("isotope") != undefined){
      var elem = document.querySelector('.random-grid');
      custom_grid_isotope = new Isotope( elem, {
          getSortData: {},
          category: "items",
          itemSelector: ".element",
          sortBy: ['original-order'],
          transitionDuration: 0,
          sortAscending: true,
          layoutMode: "packery"
        }
      );
    }
  }
  
  if(object.action == "display"){
    if($(".random-grid").attr("isotope") != undefined){
      $(".module.random-grid>.element video").each(function(){
        /* video detected */
      });
      custom_grid_isotope.layout();
    }
    
    $(".random-grid * video").each(function(){
      if(
        $(this).attr("data-ratio-w") != undefined &&
        $(this).attr("data-ratio-h") != undefined
      ){
        $(this).css({'width': "100%", height: customCalculateAspectRatioFit({'required': "height", 'original_w': $(this).attr("data-ratio-w"), 'original_h': $(this).attr("data-ratio-h"), 'max_w': $(this).width(), 'max_h': 6000 }) });
      }
    });
  }

}
/****************************************/

/****************************************/
$(window).scroll((function(event){
  customGridResponsive({'action': "display"});
}));
/****************************************/

/****************************************/
$(window).resize((function(event){
  customGridResponsive({'action': "display"});
}));
/****************************************/

/****************************************/ 
$(window).bind("load", (function(event){
  customGridResponsive({'action': "setup"});
  customGridResponsive({'action': "display"});
  setTimeout(function() {
    customGridResponsive({'action': "display"});
    $(".random-grid").addClass("active");
    custom_grid_loaded = 1;
  }, 500);
}));
/****************************************/

/****************************************/
/**
 * Aelfred custom Packery grid — filter-aware version
 * ----------------------------------------------------
 * Replaces the existing inline "Initialize Packery" script in the
 * collection template with a version that:
 *
 *   1. Lays out the grid on first page load exactly as before, using
 *      whatever mix of "_w_1_3" / "_w_2_3" the server rendered — UNLESS
 *      a filter is already active in the URL on load (e.g. a shared
 *      filtered link), in which case it normalizes immediately.
 *   2. Watches #ProductGridContainer for the DOM swap that Shopify's
 *      facets.js performs whenever a filter is applied/removed.
 *   3. On every such swap: checks whether a filter is currently selected.
 *        - If YES: forces every tile's width class to "_w_1_3" (removing
 *          "_w_2_3") before laying out — uniform grid while filtered.
 *        - If NO (filters cleared back to the full unfiltered listing):
 *          leaves the server's original "_w_1_3"/"_w_2_3" mix untouched —
 *          the normal masonry look comes back.
 *      Either way it re-initialises Packery against the *new* <li>
 *      elements, since the old instance is left pointing at nodes that
 *      no longer exist.
 *
 * How "a filter is selected" is detected:
 *   Shopify names every filter's query param "filter.*" (e.g.
 *   filter.p.product_type=Rug). Opening the price range widget without
 *   entering a value can still add empty filter.v.price.gte / .lte params
 *   to the URL, so this checks for a "filter." key with a NON-EMPTY value,
 *   not just the key's presence.
 *
 * Why the re-init is necessary (not just the class swap):
 *   - .grid-item is `position: absolute` in the CSS. Packery is what sets
 *     each item's actual left/top. It currently only ever runs once, on
 *     DOMContentLoaded.
 *   - Shopify's filter script (facets.js) rewrites the ENTIRE innerHTML of
 *     #ProductGridContainer when a filter changes — so the <ul class="grid-packery">
 *     and all its <li> children are destroyed and replaced with brand new
 *     nodes. The original Packery instance keeps pointing at the old,
 *     detached nodes; the new tiles have no left/top set, so they'd all
 *     stack on top of each other at the top-left corner without this fix.
 *
 * This file assumes the earlier fix of adding id="product-grid" back onto
 * the <ul class="grid-packery"> element (needed for the Shopify filter
 * fetch to work at all). Without that fix, filtering won't trigger a DOM
 * swap for this script to react to either.
 */
document.addEventListener('DOMContentLoaded', function () {
  var container = document.getElementById('ProductGridContainer');
  if (!container) return;

  var currentGrid = null;
  var currentPckry = null;

  // True only when at least one filter has an actual, non-empty value
  // selected — not just a widget that was opened/touched.
  function hasActiveFilter() {
    var params = new URLSearchParams(window.location.search);
    var active = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && value !== '') {
        active = true;
      }
    });
    return active;
  }

  function normalizeWidths(grid) {
    grid.querySelectorAll('.grid-item').forEach(function (item) {
      item.classList.remove('_w_2_3');
      item.classList.add('_w_1_3');
    });
  }

  // Same height logic as the original script. When a filter has forced
  // everything to "_w_1_3" the "_w_2_3" branch simply never matches.
  function updateLayout(grid) {
    var ratioAttr = grid.getAttribute('data-ratio') || '4:3';
    var parts = ratioAttr.split(':');
    var ratioWidth = parseFloat(parts[0]);
    var ratioHeight = parseFloat(parts[1]);
    var items = grid.querySelectorAll('.grid-item');

    if (window.innerWidth < 767) {
      items.forEach(function (item) {
        item.style.height = 'auto';
      });
    } else {
      var baseWidth = grid.offsetWidth / 3;
      var baseHeight = Math.round(baseWidth * (ratioHeight / ratioWidth));
      items.forEach(function (item) {
        if (item.classList.contains('_w_2_3')) {
          item.style.height = baseHeight * 2 + 'px';
        } else {
          item.style.height = baseHeight + 'px';
        }
      });
    }
  }

  function setupGrid(grid) {
    if (hasActiveFilter()) {
      normalizeWidths(grid);
    }
    updateLayout(grid);

    if (currentPckry) {
      currentPckry.destroy();
    }

    currentGrid = grid;
    currentPckry = new Packery(grid, {
      itemSelector: '.grid-item',
      percentPosition: true,
      gutter: 0,
    });

    imagesLoaded(grid).on('progress', function () {
      currentPckry.layout();
    });
  }

  // Initial page load.
  var initialGrid = container.querySelector('.grid-packery');
  if (initialGrid) setupGrid(initialGrid);

  // Re-run every time facets.js swaps the grid back in after a filter
  // change (it replaces #ProductGridContainer's innerHTML wholesale).
  new MutationObserver(function () {
    var grid = container.querySelector('.grid-packery');
    if (grid && grid !== currentGrid) {
      setupGrid(grid);
    }
  }).observe(container, { childList: true, subtree: true });

  // Resize stays bound once; always acts on whichever grid is current.
  window.addEventListener('resize', function () {
    if (!currentGrid) return;
    updateLayout(currentGrid);
    currentPckry.layout();
  });
});
/****************************************/